export default {
  header: {
    title: 'Nouvelle expédition',
    dashboard: 'Tableau de bord',
    management: 'La gestion',
    dispatches: 'Dépêches',
    client: 'Client',
    workflow: 'Flux de travail',
    program: 'Programme'
  },
  steps: {
    'Find Customer': 'Trouver un Client',
    'Select Service': 'Sélectionnez le Service',
    'Select Pick Up Time': 'Sélectionnez l\'heure de Prise en Charge',
    'Select Pick Up Location': 'Sélectionnez le lieu de Prise en Charge',
    'Select Drop Off Location': 'Sélectionnez le lieu de Dépôt',
    'Select Provider': 'Sélectionnez le Fournisseur',
    'Select Tire': 'Sélectionnez un Pneu'
  },
  forms: {
    couldNotLocateCustomerButton: 'Impossible de Localiser le Client',
    customer: 'Client',
    customerHelpText: 'Vous pouvez effectuer une recherche par prénom et nom ou marque de véhicule, modèle et année ou vin ou e-mail, ou numéro de téléphone (chiffres uniquement pour un numéro de téléphone. Pas de tirets ni de parenthèses nécessaires) ou numéro de membre',
    name: 'Nom',
    memberNumber: 'Numéro de Membre',
    email: 'E-mail',
    phones: 'Téléphones',
    address: 'Adresse',
    vehicles: 'Véhicules',
    chooseAVehicle: 'Choisissez un véhicule',
    requiredAVehicle: 'Un véhicule est requis. Modifier le client pour ajouter un véhicule',
    vinRequired: 'Le VIN du véhicule est requis. Modifier le client pour ajouter le VIN d\'un véhicule',
    addANewVehicle: 'Ajouter un nouveau véhicule',
    callerIsInASafeLocation: 'L\'appelant est dans un endroit sûr',
    antiqueVehicle: 'Le véhicule est une antiquité',
    vehicleIsLowered: 'Le véhicule est abaissé',
    forceAllServicesToCashCall: 'Forcer tous les services à payer l\'appel',
    chooseACallBackNumber: 'Choisissez un numéro de rappel',
    addCallbackNumber: 'Ajouter un numéro de rappel',
    fax: 'Fax',
    home: 'Maison',
    mobile: 'Mobile',
    other: 'Autre',
    programTfn: 'Programme TFN',
    work: 'Travailler',
    benefitLevels: 'Niveaux de prestations',
    policyDetails: 'Détails de la police',
    addresses: 'Adresses',
    customerNoPolicy: 'Aucune politique requise - Cash Call',
    customerBenefitLevelEligibilityValid: 'ÉLIGIBILITÉ À L\'AVANTAGE CLIENT: VALIDE',
    customerBenefitLevelEligibilityInvalid: 'La politique est expirée',
    policyNUmber: 'Numéro de police',
    activeDate: 'Date d\'activation',
    expirationDate: 'Date d\'expiration',
    coverage: 'Couverture',
    covered: 'Couvert',
    overMiles: 'Plus de Miles / Kilometre',
    emailNotVerified: 'COURRIEL NON VÉRIFIÉ',
    emailVerified: 'EMAIL VERIFIÉ',
    verify: 'Vérifier',
    emailNotFound: 'Email non trouvé. Veuillez cliquer ici pour mettre à jour l\'e-mail.',
    updateEmail: 'Mettre à jour l\'e-mail',
    type: 'Taper',
    phone: 'Téléphoner',
    situation: 'Situation',
    reasonForBreakdown: 'Raison de la panne',
    service: 'Service',
    yes: 'Oui',
    no: 'Non',
    vehicleAdditionalCostWarning: 'L\'ajout d\'un véhicule à ce forfait entraînera des frais supplémentaires. Êtes-vous sûr de vouloir continuer?',
    callAgentScript: 'Script d\'appel de l\'agent',
    wouldLDTBeAcceptable: 'Le remorquage léger serait-il acceptable',
    vehicleShiftsOutOfPark: 'Le véhicule sort-il du parc?',
    vehicleIsAWD: 'Le véhicule est-il 4WD (4 roues motrices) ou AWD (Toutes roues motrices)?',
    vehicleFacingForward: 'Le véhicule est-il orienté vers l\'avant ou reculé dans la place de stationnement?',
    forwardFacing: 'Face à L\'avant',
    rearFacing: 'Face à L\'arrière',
    inAParkingLot: 'Le véhicule est-il dans un parking?',
    vehicleObstructed: 'Tout autre véhicule bloquant l\'accès à votre véhicule afin d\'effectuer le service?',
    parkingLotGarageName: 'Nom du parking/garage',
    nameOfParkingLotGarage: 'Quel est le nom du parking/garage?',
    lessThanEightFootClearance: 'Y a-t-il moins de huit pieds de dégagement dans le parking/garage?',
    parkedNextToColumn: 'Êtes-vous garé à côté d\'une colonne?',
    currentlyOtherVehiclesParkedAround: 'Y a-t-il d\'autres véhicules actuellement garés autour de votre véhicule?',
    vehicleKeysInPassengerCompartment: 'Des clés dans l\'habitacle ?',
    vehicleKeysInTrunk: 'Clés dans le coffre ?',
    spaceRowNumber: 'Espace / Numéro de ligne',
    whatIsSpaceRowNumber: 'Quel est le numéro d\'espace / numéro de ligne?',
    lotGarage: 'Sol du terrain/garage',
    whatFloorIsTheVehicleLocatedOn: 'À quel étage se trouve le véhicule?',
    lotGarageFloorDesignation: 'Désignation du terrain/de l\'étage du garage',
    lotGarageFloorDesignationHelpText: 'Le niveau ou l\'étage sur lequel vous vous êtes garé a-t-il un nom, une couleur ou une désignation spécifique?',
    parkingFees: 'Frais de parking',
    parkingFeesHelperText: 'Combien coûtent les frais de stationnement associés au parking/garage?',
    inParkingGarage: 'Le véhicule se trouve-t-il dans un garage?',
    isAccident: 'Ce service résulte-t-il d\'un accident ?',
    vehicleFourWheelDrive: 'Le véhicule est-il à quatre roues motrices (4WD) ou à quatre roues motrices (AWD)?',
    vehicleHasMoreThanFourTires: 'Votre véhicule a-t-il plus de 4 pneus?',
    vehicleHasRearFlatTire: 'Votre véhicule a-t-il un pneu arrière crevé?',
    vehicleHasLivingQuarters: 'Votre véhicule dispose-t-il d\'un logement?',
    vehicleHasDuallies: 'Votre véhicule est-il équipé de deux roues?',
    trailerIsLoaded: 'La remorque est-elle chargée?',
    vehicleHeight: 'Quelle est la hauteur de votre véhicule?',
    vehicleWeight: 'Quel est le poids de votre véhicule?',
    vehicleLength: 'What is the length of your vehicle?',
    vehicleHitchType: 'Quelle est la longueur de votre véhicule?',
    towForATrailer: 'S\'agit-il d\'un remorquage pour une remorque (sans moteur)?',
    areAnyTiresFlat: 'Y a-t-il des pneus crevés?',
    noSpareIsReasonForTow: 'L\'absence de roue de secours est-elle la raison d\'un remorquage?',
    vehicleModifiedLower: 'Véhicule modifié plus bas que le sol?',
    immediate: 'Immédiat',
    scheduled: 'Programmé',
    dateAndTime: 'Date et l\'heure',
    unattendedTow: 'Remorquage sans surveillance',
    pleaseReadThisToTheCustomer: 'Veuillez lire ceci au client',
    dial911: 'Si vous êtes blessé et avez besoin d\'aide médicale, veuillez raccrocher et composer le 911.',
    haveAClaimNumber: 'Avez-vous un numéro de réclamation?',
    havePoliceBeenDispatched: 'La police a-t-elle été dépêchée?',
    arePoliceOnScene: 'La police est-elle sur place?',
    claimNumber: 'Numéro de réclamation',
    mechanical: 'Mécanique',
    accident: 'Accident',
    secondary: 'Remorquage secondaire/fourrière',
    transport: 'Le transport',
    recovery: 'Récupération',
    rvTechCall: 'Appel technique de VR',
    acknowledgeAndAgree: 'Reconnaissez-vous et acceptez-vous que le véhicule est laissé sans surveillance et renoncez à toute responsabilité?',
    changeToAttendedTow: 'Passer au remorquage assisté',
    agree: 'Accepter',
    disagree: 'Être en désaccord',
    whereAreTheKeys: 'Où sont les clés du véhicule?',
    numberOfPeopleWhoNeedARide: 'Nombre de personnes qui ont besoin d\'un transport?',
    willTheCallerBeWithTheVehicle: 'L\'appelant sera-t-il avec le véhicule?',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    useCustomerAddress: 'Utiliser l\'adresse du client',
    pickALocationOnTheMap: 'Choisissez un lieu sur la carte ou entrez un nouveau lieu',
    dispatchMap: 'Carte de répartition',
    provider: 'Fournisseur',
    searchingForAvailableProviders: 'Recherche de prestataires disponibles'
  }
};
